import { NavigateFunction } from "react-router-dom";
import { AlertType } from "../components/AlertMessage"; // adjust path if needed

export const handleLogin = (navigate: NavigateFunction) => {
  navigate("/login");
};

/**
 * Logs out the user and shows a custom alert.
 * 
 * @param logout - function to clear auth
 * @param showAlert - function to display custom alert (e.g., AlertMessage)
 * @param setShowSubnav - optional subnav setter
 */
export const handleLogout = (
  logout: () => void,
  showAlert: (message: string, type?: AlertType) => void,
  setShowSubnav?: (v: boolean) => void
) => {
  logout(); // call your logout logic from context

  showAlert("You have been logged out.", "info"); // ✅ custom alert replaces alert()

  if (setShowSubnav) setShowSubnav(false);
};
